import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { loadStylepacks } from '@/store/slices/stylepacks';
import { selectStylepacks } from '@/store/slices/stylepacks/selectors';

const useLoadStylepacks = () => {
  const dispatch = useAppDispatch();

  const stylepacks = useAppSelector(selectStylepacks);

  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current || stylepacks) {
      return;
    }
    fetched.current = true;
    dispatch(loadStylepacks());
  }, [dispatch, stylepacks]);
};

export default useLoadStylepacks;
